// Remove this when share issues have a router

import { Navigate, Route, Routes } from 'react-router-dom';
import { ShareIssueShow } from './Show';
import { ShareIssueSummaryShow } from './component/SummaryShow';
import { SiDocumentsShow } from './component/DocumentsShow';
import { ParticipantsTable } from './component/ParticipantsTable';
import { GenericError } from '@startuptools/ui/Error';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useShareIssueSuspenseQuery } from './ShareIssue.graphql';
import { useNavigate } from '../../components/Navigate';

export const ShareIssueShowWithRouter = ({ shareIssueId }: { shareIssueId: string }) => {
  const companyId = useCompanyId();
  const { pathname } = useNavigate();
  const {
    data: { shareIssue },
  } = useShareIssueSuspenseQuery({ variables: { companyId, shareIssueId } });
  const shareIssueRegistration = shareIssue.shareIssueRegistrations.at(0)!;

  const sips = shareIssueRegistration.participants;

  if (pathname.endsWith('show')) {
    return <Navigate to="summary" replace />;
  }

  return (
    <Routes>
      <Route path="" element={<ShareIssueShow shareIssueId={shareIssueId} />} errorElement={<GenericError />}>
        <Route index path="summary" element={<ShareIssueSummaryShow shareIssueId={shareIssueId} />} />
        <Route path="documents" element={<SiDocumentsShow shareIssueId={shareIssueId} />} />
        <Route
          path="participants"
          element={
            <ParticipantsTable
              shareIssue={shareIssue}
              sips={sips}
              paymentKind={null}
              sirId={shareIssueRegistration.id}
            />
          }
        />
      </Route>
    </Routes>
  );
};
